const state = {
    peopleGroups: [],
    organizationalCommunications: []
};

const mutations = {
    setPeopleGroups(state, value) {
        state.peopleGroups = value;
    },
    setOrganizationalCommunications(state, value) {
        state.organizationalCommunications = value;
    },
};

const actions = {};

const getters = {
    peopleGroups: (state) => state.peopleGroups,
    organizationalCommunications: (state) => state.organizationalCommunications,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
